import { useEffect, useState } from 'react'

export type ScriptStatus = 'LOADING' | 'LOADED' | 'ERROR'

export const useRemoteScript = (src: string): ScriptStatus => {
  const [status, setStatus] = useState('LOADING') as [
    ScriptStatus,
    (status: ScriptStatus) => void
  ]

  useEffect(() => {
    const onError = () => setStatus('ERROR')
    const onLoad = () => setStatus('LOADED')

    const script: HTMLScriptElement | null = document.querySelector(
      `script[src="${src}"]`
    )

    if (!script) {
      setStatus('LOADING')

      const newScript: HTMLScriptElement = document.createElement('script')
      newScript.src = src
      newScript.async = true

      newScript.addEventListener('error', () => {
        onError()
        document.body.removeChild(newScript)
      })
      newScript.addEventListener('load', () => {
        onLoad()
        newScript.dataset.loaded = 'true'
      })

      document.body.appendChild(newScript)
    } else if (script.dataset.loaded) {
      onLoad()
    } else {
      setStatus('LOADING')

      script.addEventListener('error', onError)
      script.addEventListener('load', onLoad)
    }
  }, [src])

  return status
}
